export const SET_LOADER = "SET_LOADER";

export const setLoader = (showLoader) => {
  return (dispatch) =>
    dispatch({
      type: SET_LOADER,
      payload:showLoader,
    });
};
